/* unplugin-vue-components disabled */import script from "./deviceflat.vue?vue&type=script&setup=true&name=DeviceFlat&lang=js"
export * from "./deviceflat.vue?vue&type=script&setup=true&name=DeviceFlat&lang=js"

import "./deviceflat.vue?vue&type=style&index=0&id=1fc12746&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fc12746"]])

export default __exports__